module.exports = __webpack_public_path__ + "img/ag.52df7dae.svg";